export const errorMessage = 'Something went wrong. Please try again.';
export const noDataMessage = 'No data. Something went wrong. Please try again.';

export const deleteError = 'Unable to delete Phone Number. Please try again later.';
export const deleteSuccess = 'Phone Number has been successfully deleted.';
